import { endOfMonth, endOfWeek, startOfMonth, startOfWeek } from "date-fns";
import { fetchMonthlyTimesheet } from "@/modules/timesheet/logs/views/calendar/api";
import { monthYearKey } from "utils";
import { timesheetKeys } from "components/timesheet/queries";
import { useFetch } from "@/hooks/useFetch";

export default function useMonthlyTimesheet(date) {
  const firstDayOfMonth = startOfMonth(date);
  const lastDayOfMonth = endOfMonth(date);
  const calendarStart = startOfWeek(firstDayOfMonth, { weekStartsOn: 1 }); // 1 = Monday
  const calendarEnd = endOfWeek(lastDayOfMonth, { weekStartsOn: 1 });

  const { data: timesheetData, isLoading } = useFetch({
    queryKey: timesheetKeys.logCalendar(monthYearKey(firstDayOfMonth)),
    queryFn: () => fetchMonthlyTimesheet(calendarStart, calendarEnd),
  });

  const transformTimesheetData = () => {
    if (!timesheetData) return {};

    return timesheetData.reduce((acc, entry) => {
      const dateStr = entry.date;

      if (!acc[dateStr]) {
        acc[dateStr] = [];
      }

      acc[dateStr].push({
        id: entry.id,
        name: entry.description || "No description",
        time: "",
        datetime: `${dateStr}T00:00`,
        href: "#",
        hours: entry.logged_hours,
        project: entry.project?.name || "No project",
        jobId: entry.job?.id,
        approved: entry.approved_hours,
        unapproved: entry.unapproved_hours,
      });

      return acc;
    }, {});
  };

  return {
    timesheetData,
    isLoading,
    transformedData: transformTimesheetData(),
  };
}
